import crisisInterventionQuestionSet from "../faq/crisitIntervention/allQuestions";

export const crisisIntervention = {
    'meta': {
        'title': 'Interwencja kryzysowa #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Interwencja kryzysowa jest działaniem krótkoterminowym i doraźnym, którego  celem jest udzielenie natychmiastowej pomocy w kryzysie życiowym.'
    },
    'availability': [
        'torun'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/interwencja-kryzysowa/',
        'title': 'Interwencja kryzysowa #cityLocativeIn#',
        'name': 'Interwencja kryzysowa #cityLocativeIn#',
        'heading': 'Interwencja kryzysowa #cityLocativeIn#',
        'fullName': 'Interwencja kryzysowa'
    },
    'image': {
        'url': '/images/services/interwencja-kryzysowa-w-toruniu.webp',
        'width': 886,
        'height': 295,
        'alt': 'Interwencja kryzysowa #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/open-graph/interwencja-kryzysowa-w-toruniu.jpg',
            'width': 886,
            'height': 295,
            'alt': 'Interwencja kryzysowa #cityLocativeIn#'
        }
    },
    'faq': crisisInterventionQuestionSet
}